import { useState } from 'react';
import { signInInternal } from '../lib/auth';
import { useAuth } from '../AuthContext';

export default function Login() {
  const { enterDemo } = useAuth();
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function go() {
    setErr(''); setBusy(true);
    try { await signInInternal(); }
    catch (e: any) { setErr(e?.message || 'Sign-in failed.'); }
    finally { setBusy(false); }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-mark">M</div>
        <div className="login-title">MFX CRM</div>
        <div className="login-sub">Microflex Film — customer, client &amp; vendor system</div>

        <button className="btn btn-primary" onClick={go} disabled={busy}>
          {busy ? 'Opening Google…' : 'Sign in with Microflex Workspace'}
        </button>
        <button className="btn btn-ghost" onClick={enterDemo}>
          Browse demo data (no sign-in)
        </button>

        {err && <div className="login-err">{err}</div>}
        <div className="login-foot">Restricted to @microflexfilm.com accounts · mfx-2026</div>
      </div>
    </div>
  );
}
